import axios from 'axios';
import { Storage } from '@/utils/storage';
import logger from '../logger';
import coordTransform from './coordTransform';
import { regeoCodingSearch } from './lbs';

const H5_LOCATION_CACHE = 'h5-location-cache';
const H5_SHORT_TIME_LOCATION_CACHE = 'h5-short-time-location-cache';
// eslint-disable-next-line no-unused-vars
let _cityInfoResultCache;

const formatRegeocode = (regeocodeItem, { longitude, latitude } = {}) => {
  // eslint-disable-next-line camelcase
  const { formatted_address, formattedAddress, addressComponent } = regeocodeItem;
  const {
    adCode, adcode, cityCode, citycode, city,
  } = addressComponent;
  const __adcode = adCode || adcode;
  const __citycode = cityCode || citycode;
  const _adcode = Array.isArray(__adcode) ? '' : __adcode;
  const _citycode = Array.isArray(__citycode) ? '' : __citycode;
  const _city = Array.isArray(city) ? '' : city;
  const formattedRegeocode = {
    ...addressComponent,
    adcode: _adcode,
    adCode: _adcode,
    citycode: _citycode,
    cityCode: _citycode,
    city: _city,
    accurateCityCode: _citycode,
    accurateAdCode: _adcode,
    // eslint-disable-next-line camelcase
    formattedAddress: formatted_address || formattedAddress,
    accurateLongitude: longitude,
    accurateLatitude: latitude,
    longitude: addressComponent.longitude || longitude,
    latitude: addressComponent.latitude || latitude,
  };
  return formattedRegeocode;
};
// 高德逆地理
const regeocodeGaode = async ({ lng, lat }) => {
  const { regeocode } = await axios.get(
    `https://restapi.amap.com/v3/geocode/regeo?key=5d9fc0e0afe791858698fad9679bdfe2&location=${lng},${lat}&radius=100`,
  );
  logger.warn('高德逆地理:', regeocode);
  const { addressComponent } = regeocode || {};
  if (!addressComponent) {
    throw new Error('高德逆地理无数据');
  }
  // 地址格式标准化处理
  return formatRegeocode(regeocode, { longitude: lng, latitude: lat });
};
// 哈啰地图平台LBS服务逆地理
const regeocodeHello = async ({ lng, lat }) => {
  // 经纬度逆地理
  const res = await regeoCodingSearch({ lat, lng, ...window.HBridgeCustomLBSConfig });
  if (!res || !res.data) {
    throw new Error('LBS逆地理无数据');
  }
  const { status, data } = res.data;
  if (Number(status) !== 1) {
    throw new Error('LBS逆地理编码状态错误');
  }
  if (!data || !data.reGeoCodesListStandard || !data.reGeoCodesListStandard.length) {
    throw new Error('LBS逆地理数据不完整');
  }
  logger.warn('哈啰逆地理:', data);
  // 地址格式标准化处理
  return formatRegeocode(
    data.reGeoCodesListStandard[0],
    { longitude: lng, latitude: lat },
  );
};
// 逆地理
export const regeocode = async (params) => {
  try {
    return await regeocodeHello(params);
  } catch (ex) {
    return regeocodeGaode(params);
  }
};
// 浏览器原生定位
const getLocationByNavigator = () => new Promise((resolve, reject) => {
  if (navigator.geolocation) {
    if (typeof navigator.geolocation.getCurrentPosition === 'function') {
      navigator.geolocation.getCurrentPosition((res) => {
        logger.warn('getLocationByNavigator:', res.coords);
        if (res.coords && res.coords.longitude && res.coords.latitude) {
          const {
            longitude, latitude,
          } = res.coords;
          // WGS84坐标转换为GCJ02
          const [lng, lat] = coordTransform(
            [longitude, latitude],
          );
          resolve({
            lng, lat,
          });
        } else {
          reject(new Error('navigator.geolocation.getCurrentPosition failed'));
        }
      },
      (err) => {
        reject(err);
      },
      {
        enableHighAccuracy: false,
        timeout: 5000,
        maximumAge: 0,
        coordsType: 'wgs84',
      });
    }
  } else {
    reject(new Error('navigator.geolocation is not supported'));
  }
});

const loadCityInfo = async () => {
  const position = {
    lng: '',
    lat: '',
  };
  // 获取定位
  const { lng, lat } = await getLocationByNavigator();
  position.lng = lng;
  position.lat = lat;
  return regeocode(position);
};

export default class AMapHelper {
  /**
   * 获取定位以及cityCode、adCode
   *
   * 一级缓存：内存级缓存，当前页面生命周期内不重新获取
   * 二级缓存：15秒localStorage缓存，刷新页面15秒内不重新获取
   * 三级缓存：天级缓存，每次获取城市信息成功后刷新，失败则不刷新，一天后过期
   */
  static async getCityInfo() {
    // 内存缓存
    // if (_cityInfoResultCache) {
    //   return _cityInfoResultCache;
    // }
    // // 短时间（15s）缓存
    // const shortTimeLocationCache = Storage.getItem(H5_SHORT_TIME_LOCATION_CACHE);
    // if (shortTimeLocationCache) {
    //   return shortTimeLocationCache;
    // }
    // 刷新定位
    const reLocate = loadCityInfo()
      .then((result) => {
        // 天级缓存，每次请求先返回再刷新
        Storage.setItem(
          H5_LOCATION_CACHE,
          { _fromCache: 'dayCache', ...result },
          new Date(new Date().getTime() + 86400000),
        );
        // 短时间缓存
        Storage.setItem(
          H5_SHORT_TIME_LOCATION_CACHE,
          { _fromCache: 'shortTimeCache', ...result },
          new Date(new Date().getTime() + 15000),
        );
        // 内存缓存
        // 为了确保进入第一次请求都使用天级缓存，加快页面响应速度，所以这里延迟到定位成功后赋值
        _cityInfoResultCache = {
          _fromCache: 'memoryCache',
          ...result,
        };
        return result;
      })
      .catch((ex) => {
        logger.warn(ex);
      });
    // 定位时优先返回天级缓存
    // const cacheLocation = Storage.getItem(H5_LOCATION_CACHE);
    // if (cacheLocation) {
    //   return cacheLocation;
    // }
    return reLocate;
  }
}
